import request from '@/utils/request';

export function getOrders (filter) {
  return request.get('api/admin/orders', filter);
}

export function getOrdersByTime (filter) {
  return request.get('api/admin/orders/times', filter);
}

export function getOrderConfig () {
  return request.get('/api/admin/orders/config');
}



// WEBPACK FOOTER //
// ./src/api/orders.js